/* Teeez: the theme blocks horizontal touch scrolling site wide (it uses the
   gesture for its own sliders). Allow it inside Teeez swipe areas. */
(() => {
  if (window.teeezSwipeUnlock) return;
  window.teeezSwipeUnlock = true;
  const SEL = '.teeez-hero__track, .teeez-cols__track, .template--index carousel-root .carousel--x-container';
  const setFlag = (v) => { if (window.theme && theme.utils) theme.utils.disable_prevent_scroll = v; };
  document.addEventListener('touchstart', (e) => {
    if (e.target.closest && e.target.closest(SEL)) setFlag(true);
  }, { capture: true, passive: true });
  const off = () => setFlag(false);
  document.addEventListener('touchend', off, { capture: true, passive: true });
  document.addEventListener('touchcancel', off, { capture: true, passive: true });
})();
